import { axiosWithAuth } from "helpers";

export const merchantRiskService = {
	getMerchantRiskData,
	updateMerchantRisk,
};

const API_URL = process.env.REACT_APP_API_URL;

function getMerchantRiskData(merchantId) {
	const options = {
		method: "GET",
		url: `${API_URL}/api/merchants/${merchantId}/risk`,
	};

	return axiosWithAuth(options);
}

function updateMerchantRisk({
	merchantId,
	fieldsData,
}: {
	merchantId: string;
	fieldsData: {
		fieldBeName: string;
		fieldValue: Date | string | number | null | undefined;
	}[];
}) {
	const options = {
		method: "PATCH",
		data: fieldsData.map(({ fieldBeName, fieldValue }) => ({
			value: fieldValue,
			path: `/${fieldBeName}`,
			op: "replace",
		})),
		url: `${API_URL}/api/merchants/${merchantId}/risk`,
		headers: { "Content-Type": "application/json-patch+json" },
	};

	return axiosWithAuth(options);
}
